"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var axios_client_service_1 = require("../../axios-client/axios-client.service");
var invoicing_const_1 = require("./invoicing.const");
/**
 * InvoicingService
 * @class
 */
var InvoicingService = /** @class */ (function () {
    function InvoicingService() {
    }
    /**
     * Returns an array of invoices bound to a given user(`userUuid`)
     * @param user {string}
     * @returns Invoice[]
     */
    InvoicingService.prototype.getIndex = function (user, version) {
        if (version === void 0) { version = 'v1'; }
        var url = invoicing_const_1.INVOICING_ENDPOINT.getIndex
            .replace('{{version}}', version)
            .replace('{{userUuid}}', user);
        return axios_client_service_1.axiosClientInstance.get(url);
    };
    /**
     * Returns the details of a given invoice (`invoiceUuid`)
     * @param invoice {string}
     * @returns Invoice
     */
    InvoicingService.prototype.getInvoice = function (invoice, version) {
        if (version === void 0) { version = 'v1'; }
        var url = invoicing_const_1.INVOICING_ENDPOINT.getInvoice
            .replace('{{version}}', version)
            .replace('{{invoiceUuid}}', invoice);
        return axios_client_service_1.axiosClientInstance.get(url);
    };
    /**
     * Triggers an given invoice payment (`invoiceUuid`)
     * @param invoice {string}
     * @returns Invoice
     */
    InvoicingService.prototype.putPayInvoices = function (invoice, version) {
        if (version === void 0) { version = 'v1'; }
        var url = invoicing_const_1.INVOICING_ENDPOINT.putPayInvoice
            .replace('{{version}}', version)
            .replace('{{invoiceUuid}}', invoice);
        return axios_client_service_1.axiosClientInstance.put(url);
    };
    return InvoicingService;
}());
/**
 * External InvoicingService Class Instance
 * @namespace
 */
exports.invoicing = new InvoicingService();
